import * as yup from 'yup';
import { Phone } from '~/core/entities/phone';

export function isValidPhone(this: yup.StringSchema, message: string) {
	return this.test({
		name: 'phone',
		message,
		test: (value: string | undefined) => {
			if (value === undefined) {
				return false;
			}

			const phone = new Phone(value);

			return phone.isValid();
		}
	});
}

yup.addMethod(yup.string, 'phone', isValidPhone);
